import { render, staticRenderFns } from "./MainStatus.vue?vue&type=template&id=107c7322&scoped=true&"
import script from "./MainStatus.vue?vue&type=script&lang=js&"
export * from "./MainStatus.vue?vue&type=script&lang=js&"
import style0 from "./MainStatus.vue?vue&type=style&index=0&id=107c7322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107c7322",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107c7322')) {
      api.createRecord('107c7322', component.options)
    } else {
      api.reload('107c7322', component.options)
    }
    module.hot.accept("./MainStatus.vue?vue&type=template&id=107c7322&scoped=true&", function () {
      api.rerender('107c7322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/MainStatus.vue"
export default component.exports